import React from "react";

import {pluralize} from "@pg-mono/string-utils";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const FloorsCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    return <>{`${property.floors} ${floorsPlural(property.floors)}${property.has_attic ? " w tym poddasze" : ""}`}</>;
};

const floorsPlural = pluralize(["poziom", "poziomy", "poziomy"]);
import React from "react";

import {pluralize} from "@pg-mono/string-utils";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const FloorsCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    return <>{`${property.floors} ${floorsPlural(property.floors)}${property.has_attic ? " w tym poddasze" : ""}`}</>;
};

const floorsPlural = pluralize(["poziom", "poziomy", "poziomy"]);
